import { DateField } from './DateField'

/** „Sold la data" — camp cu calendar, acelasi component ca la filtrele din eMag. */
export function AsOfField({
  value,
  onChange,
  coverage,
}: {
  value: string
  onChange: (v: string) => void
  /** Ultima zi acoperita de extrasele bancare (AAAA-LL-ZZ). */
  coverage: string | null
}) {
  return (
    <>
      <div className="w-36">
        <DateField value={value} onChange={onChange} />
      </div>
      {/* Scurtatura la ultima zi acoperita de extrase — soldul de acolo e cel complet. */}
      {coverage && value !== coverage && (
        <button
          type="button"
          onClick={() => onChange(coverage)}
          className="text-xs text-b4l-blue hover:underline whitespace-nowrap"
          title="Ultima zi acoperita de extrasele bancare incarcate"
        >
          ultimul extras
        </button>
      )}
    </>
  )
}
